module.exports = __webpack_public_path__ + "static/img/bystage_white_05.383393ad.svg";